// Mycontext.js
import React, { createContext, useState } from 'react';

export const Mycontext = createContext();

export const MycontextProvider = ({ children }) => {
  const [isFavoriteVisible, setIsFavoriteVisible] = useState(false);
  const [cartItemsCount, setCartItemsCount] = useState(0);
  const [cartItemsData, setCartItemsData] = useState([]);

  return (
    <Mycontext.Provider value={{ isFavoriteVisible, setIsFavoriteVisible, cartItemsData,setCartItemsData,
      cartItemsCount, setCartItemsCount  }}>
      {children}
    </Mycontext.Provider>
  );
};